# GraphQL fragment to get basic info about a step template
# within the sales automation environment.

mutation DeleteStepTemplate($stepTemplate: DeleteStepTemplateInputFieldInput!) {
    deleteStepTemplate(input: {stepTemplate: $stepTemplate}) {
        stepTemplate {
            id
        }
    }
}
